import React from "react";
import "./KioskPricingTable.css"; 
import { FormattedMessage} from "react-intl";
import SideFlag from "../../../images/additional_img/side_flag.svg"; 

export default function Index() {
    return (
        <div className="kiosk_pricing_container">
            <div className="kiosk_pricing_station_base">
                <div className="kiosk_pricing_base">
                    <div className="base_title_container">
                        <h1><FormattedMessage id={"clover_kiosk"}/></h1>
                    </div>
                    <div className="base_layout_grid">
                        <div className="price_card">
                            <h2 className="pricing">
                                $155
                                <span className="length_text"><FormattedMessage id={"month"}/></span>
                            </h2>
                            <h3 className="price_type"><FormattedMessage id={"lease_to_own"}/></h3>
                            <div className="pricing-features">
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"three_years_term"}/></div>
                                </div>
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"payment_end"}/></div>
                                </div>
                            </div>
                        </div>
                        <div className="price_card">
                            <h2 className="pricing">
                                $3,600
                                <span className="length_text"> <FormattedMessage id={"one_time"}/></span>
                            </h2>
                            <h3 className="price_type"><FormattedMessage id={"purchase"}/></h3>
                            <div class="w-layout-grid pricing-features">
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"cheapest_cost"}/></div>
                                </div>
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"one_year_manufacturer"}/></div>
                                </div>
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"no_monthly_fees"}/></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="paragraph_container">
                        <h3 className="price_type"><FormattedMessage id={"optional_accessories"}/></h3>
                    </div>
                    <div className="base_layout_grid">
                        <div className="price_card">
                            <h3 className="device_type"><FormattedMessage id={"clover_wall_mount"}/></h3>
                            <h4>
                                $99
                                <span className="length_text"> <FormattedMessage id={"one_time"}/></span>
                            </h4>
                            <h3 className="device_type"><FormattedMessage id={"purchase"}/></h3>
                        </div>
                        <div className="price_card">
                            <h3 className="device_type"><FormattedMessage id={"clover_stand"}/></h3>
                            <h4>
                                $949
                                <span className="length_text"> <FormattedMessage id={"one_time"}/></span>
                            </h4>
                            <h3 className="device_type"><FormattedMessage id={"purchase"}/></h3>
                        </div>
                    </div>
                    <div className="paragraph_container">
                        <h3 className="price_type"><FormattedMessage id={"clover_kiosk_software"}/></h3>
                        <h3>
                            $59
                            <span className="length_text"><FormattedMessage id={"month"}/></span>
                        </h3>
                    </div>
                    <p className="highlight_content"><FormattedMessage id={"require_tax"}/></p>
                </div>
                <div className="kiosk_pricing_base">
                    <div className="base_title_container">
                        <h1><FormattedMessage id={"samsung_without_stand"}/></h1>
                    </div>
                    <div className="base_layout_grid">
                        <div className="price_card">
                            <h2 className="pricing">
                                $199
                                <span className="length_text"><FormattedMessage id={"month"}/></span>
                            </h2>
                            <h3 className="price_type"><FormattedMessage id={"lease_to_own"}/></h3>
                            <div className="pricing-features">
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"three_years_term"}/></div>
                                </div>
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"payment_end"}/></div>
                                </div>
                            </div>
                        </div>
                        <div className="price_card">
                            <h2 className="pricing">
                                $5,900
                                <span className="length_text"> <FormattedMessage id={"one_time"}/></span>
                            </h2>
                            <h3 className="price_type"><FormattedMessage id={"purchase"}/></h3>
                            <div class="w-layout-grid pricing-features">
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"cheapest_cost"}/></div>
                                </div>
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"one_year_manufacturer"}/></div>
                                </div>
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"no_monthly_fees"}/></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="paragraph_container">
                        <h3 className="price_type"><FormattedMessage id={"samsung_kiosk_software"}/></h3>
                        <h3>
                            $99
                            <span className="length_text"><FormattedMessage id={"month"}/></span>
                        </h3>
                    </div>
                    <p className="highlight_content"><FormattedMessage id={"require_tax_clover"}/></p>
                </div>
                <div className="kiosk_pricing_base">
                    <div className="base_title_container">
                        <h1><FormattedMessage id={"samsung_with_stand"}/></h1>
                    </div>
                    <div className="base_layout_grid">
                        <div className="price_card">
                            <h2 className="pricing">
                                $219
                                <span className="length_text"><FormattedMessage id={"month"}/></span>
                            </h2>
                            <h3 className="price_type"><FormattedMessage id={"lease_to_own"}/></h3>
                            <div className="pricing-features">
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"three_years_term"}/></div>
                                </div>
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"payment_end"}/></div>
                                </div>
                            </div>
                        </div>
                        <div className="price_card">
                            <h2 className="pricing">
                                $6,500
                                <span className="length_text"> <FormattedMessage id={"one_time"}/></span>
                            </h2>
                            <h3 className="price_type"><FormattedMessage id={"purchase"}/></h3>
                            <div class="w-layout-grid pricing-features">
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"cheapest_cost"}/></div>
                                </div>
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"one_year_manufacturer"}/></div>
                                </div>
                                <div className="check-wrap">
                                    <img src={SideFlag} className="check"/>
                                    <div className="feature-text"><FormattedMessage id={"no_monthly_fees"}/></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="paragraph_container">
                        <h3 className="price_type"><FormattedMessage id={"samsung_kiosk_software"}/></h3>
                        <h3>
                            $99
                            <span className="length_text"><FormattedMessage id={"month"}/></span>
                        </h3>
                    </div>
                    <p className="highlight_content"><FormattedMessage id={"require_tax_clover"}/></p>
                </div>

                {/* <div className="kiosk_pricing_base">
                    <div className="base_title_container">
                        <h1><FormattedMessage id={"kiosk_software"}/></h1>
                    </div>
                    <div className="base_layout_grid">
                        <div className="price_card">
                            <h3 className="price_type"><FormattedMessage id={"clover_kiosk"}/></h3>
                            <h2 className="pricing">
                                $59
                                <span className="length_text"><FormattedMessage id={"month"}/></span>
                            </h2>
                            <p className="highlight_content"><FormattedMessage id={"require_tax"}/></p>
                        </div>
                        <div className="price_card">
                            <h3 className="price_type"><FormattedMessage id={"samsung_kiosk"}/></h3>
                            <h2 className="pricing">
                                $99
                                <span className="length_text"><FormattedMessage id={"month"}/></span>
                            </h2>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    )
}